// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.users', {
        url: '/users?searchTerm',
        views: {
            "contactList@contacts": {
                templateUrl: 'main/contacts/users/users.tpl.html',
                controller: 'ContactsUsersController as vm'
            }
        },
        resolve: {
            users: usersResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function usersResolver(UsersApiService,$stateParams) {
    return UsersApiService.getAll({searchTerm:$stateParams.searchTerm,showInactiveUsers:false});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function ContactsUsersController($scope,$state, $rootScope, users,UsersApiService,loadSpinnerService,AuthService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;
    vm.userList = generateUserList(users);
    vm.selectedUserId = 0;
    vm.selectUser = selectUser;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.searchTermChanged = searchTermChanged;
    vm.canAccess = AuthService.canAccess;
    vm.showExtraOptions = false;
    vm.showInactiveUsers = false;

    activate();

    function activate() {
        $rootScope.$on('User.Inserted', function(event, response) {
            loadUsers();
        });
        $rootScope.$on('User.Changed', function(event, response) {
            loadUsers();
        });
    }

    function selectUser(user) {
        if (AuthService.canAccess('user', 'read')) {
            $state.go('contacts.users.user', {userId: user.id});
        }
    }

    function generateUserList(users) {
        var list = [];

        _.forEach(users,function(user) {
            if(!isCleverAppsUser(user) || cleverAppsLoggedIn()){
                var userCopy = _.clone(user);
                var mobileNumber = _.find(user.contactInfos, { contactInfoType: { systemTypeName: 'Mobile'}});
                userCopy.mobileNumber = mobileNumber ? mobileNumber.value : '';
                list.push(userCopy);
            }
        });

        return _.sortBy(list, ['firstName']);
    }

    function searchTermChanged() {
        loadUsers();
    }

    function loadUsers() {
        loadSpinnerService.start('mainSpinner');
        UsersApiService.getAll({searchTerm: vm.searchTerm, showInactiveUsers: vm.showInactiveUsers}).then(function (response) {
            vm.userList = generateUserList(response);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

    function isCleverAppsUser(user){
        return user.firstName.toLowerCase() === "cleverapps"
            && (user.lastName.toLowerCase() === "superuser" || 
                user.lastName.toLowerCase() === "support" || 
                user.lastName.toLowerCase() === "thomas sverker" || 
                user.lastName.toLowerCase().includes("integration"))
            && (user.username.toLowerCase() === "superuser" || 
                user.username.toLowerCase() === "support" || 
                user.username.toLowerCase() === "thsv" || 
                user.username.toLowerCase().includes("integration"))
    }

    function cleverAppsLoggedIn(){
        return $rootScope.currentUser.firstName === "CleverApps"
            && ($rootScope.currentUser.lastName === "Superuser" || 
                $rootScope.currentUser.lastName === "Support" || 
                $rootScope.currentUser.lastName === "Thomas Sverker")
            && ($rootScope.currentUser.username === "superuser" || 
                $rootScope.currentUser.username === "support" || 
                $rootScope.currentUser.username === "thsv")
    }

    $scope.$watch(function() { return $state.params.userId; }, function(newValue, oldValue) {
        vm.selectedUserId = parseInt($state.params.userId,10);
    });
}

angular.module('contacts.users', ['users.api', 'contacts.users.user', 'contacts.users.userPrintQRCodeDialog'])
    .config(stateConfig)
    .controller('ContactsUsersController', ContactsUsersController);
